import { useEffect, useState } from "react";
import { Button, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { appRoles } from "../../../const/general/roles";
import { openEmptyDialogUser } from "../../../redux/reducers/dialogUser-reducer";
import { ProgressBarDisponibilitaLinear } from "../../Disponibilita/componentsViewDisponibilita/ProgressBarDisponibilita";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate } from "@fortawesome/free-solid-svg-icons";

export const sincronizzazione = "sincronizzazione";
const taskMustBlockActivity = [1, 2];

export default function SynchronizeButton({ task = null }) {
  const { t } = useTranslation();
  const state = useSelector((state) => state.userDate);
  const taskState = useSelector((state) => state.taskAsync.utentiSincronizzazione);
  const dispatch = useDispatch();
  const [oldTaskPercentage, setOldTaskPercentage] = useState(0);

  //gestisce il rendering delle percentuali nella progressbar
  useEffect(() => {
    if (taskState?.taskObj?.taskPercentage) {
      if (taskState?.taskObj?.taskPercentage > oldTaskPercentage)
        setOldTaskPercentage(taskState?.taskObj?.taskPercentage);
    } else {
      setOldTaskPercentage(0);
    }
  }, [taskState?.taskObj?.taskPercentage]);

  return (
    state.roles.includes(appRoles.admin) &&
    (taskState?.taskObj === null || !taskMustBlockActivity.includes(taskState.taskObj.taskType) ? (
      <>
        <Tooltip title={t("synchronization")}>
          <div className="buttonBoxToolbar">
            <Button
              variant="outlined"
              startIcon={<FontAwesomeIcon icon={faRotate} />}
              size="small"
              sx={{ color: "#3e6bb4" }}
              onClick={() => dispatch(openEmptyDialogUser(sincronizzazione))}
            >
              {t("synchronization")}
            </Button>
          </div>
        </Tooltip>
      </>
    ) : (
      <>
        <Tooltip title={t("synchronization")}>
          <div className="buttonBoxToolbar">
            <Button
              variant="outlined"
              startIcon={<FontAwesomeIcon icon={faRotate} />}
              size="small"
              sx={{ color: "#3e6bb4" }}
              disabled
            >
              {t("synchronization") + "..."}
              <div className="flex-center-center">
                <ProgressBarDisponibilitaLinear
                  value={Math.max(taskState?.taskObj?.taskPercentage, oldTaskPercentage)}
                  style={{ width: "105px" }}
                />
              </div>
            </Button>
          </div>
        </Tooltip>
      </>
    ))
  );
}
